import { render, staticRenderFns } from "./TicketsHeading.vue?vue&type=template&id=3015f5c2&scoped=true&"
import script from "./TicketsHeading.vue?vue&type=script&lang=js&"
export * from "./TicketsHeading.vue?vue&type=script&lang=js&"
import style0 from "./TicketsHeading.vue?vue&type=style&index=0&id=3015f5c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3015f5c2",
  null
  
)

export default component.exports